import React from 'react';

const FaqEmptyScreen = () => {
  return (
    <div className="flex justify-center items-center h-[144px]">
      <label className="md:font-normal italic md:text-base text-[#5F5F5F] select-none">
        Choose to upload the File or Link from the Button
      </label>
    </div>
  );
};
export default FaqEmptyScreen;
